import React, {useState, useRef} from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const modalStyles = {
  overlay: {
    zIndex: '1050'
  },
  content: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    padding: '0',
    border: '0',
    overflow: 'hidden'
  }
};

const ModalSearchMask = ({show, title, toggleModal, header, children, bottom, classes}) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);

  const contentClasses = classnames(`pt-4 px-3 position-relative ${classes?.content}`);

  const calcHeaderHeigth = () => setHeaderHeight(headerRef?.current?.clientHeight ?? 0);

  return (
    <Modal
      isOpen={show}
      style={modalStyles}
      ariaHideApp={false}
      onAfterOpen={calcHeaderHeigth}
      bodyOpenClassName="modal-open"
      closeTimeoutMS={300}
    >
      <div ref={headerRef}>
        <div className="px-3 pt-3 position-relative">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="font-bold display-4">{title}</h4>
            <button type="button" className="close" onClick={toggleModal}>
              <span aria-hidden="true"><i className="icon icon-e-remove" /></span>
            </button>
          </div>
          {header}
        </div>
        <div className="pt-4 modal-shadow-bottom" />
      </div>
      <div
        className={contentClasses}
        style={{
          height: `calc(100vh - ${headerHeight}px)`,
          overflow: 'scroll'
        }}
      >
        {children}
      </div>
      {
        bottom &&
          <div
            className="w-1-1"
            style={{position: 'fixed', left: 0, bottom: 0}}
          >
            {bottom}
          </div>
      }
    </Modal>
  );
};

ModalSearchMask.defaultProps = {
  classes: {}
};

ModalSearchMask.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  bottom: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  classes: PropTypes.object
};

export default ModalSearchMask;
